import { generateSectionalIds, populateFields } from "./"

export const mergeAssetsWithForm = (form: any[], assets: any) => {
  form.forEach((tab: any) => updateTabFields(tab.fields, assets))
};

const updateTabFields = (fields: any[], assets: any) => {
  fields.forEach((field: any) => {
    if(field.assetId && assets[field.assetId] && assets[field.assetId].json) {
      const data = assets[field.assetId].json
      const fieldsToSkip = ["id", "fields", "assetInstanceId", "assetBindPrefix"]
      const assetFieldKeys = Object.keys(data).filter((el: any) => !fieldsToSkip.includes(el))

      assetFieldKeys.forEach((item: any) => {
        field[item] = data[item]
      })

      if (field.type === "Container" || field.type === "Section") {
        const copyOfData = JSON.parse(JSON.stringify(data))
        populateFields(copyOfData.fields, { assetInstanceId: field.assetInstanceId })
        const updatedFields = generateSectionalIds({ json: copyOfData }, field.id);
        field.fields = updatedFields.fields;
      }

      return
    }

    if(field.fields) {
      updateTabFields(field.fields, assets)
    }
  })
}
